import type { FC, ReactNode } from 'react';
import useFloatingLabel from '@/ui/hooks/use-floating-label';
import cn from '@/ui/utils/cn/cn';
import { useFormField } from './Form';

import $ from './Form.module.scss';

type FloatingLabelWrapperProps = {
  fieldValue: any;
  label: string;
  required?: boolean;
  disabled?: boolean;
  children: (handlers: {
    handleFocus: () => void;
    handleBlur: () => void;
    id: string;
  }) => ReactNode;
  className?: string;
};

const FloatingLabelWrapper: FC<FloatingLabelWrapperProps> = ({
  fieldValue,
  label,
  required = false,
  disabled = false,
  children,
  className,
}) => {
  const { formItemId } = useFormField();
  const {
    showFloatingLabel,
    handleFocus,
    handleBlur,
    handleMouseEnter,
    handleMouseLeave,
  } = useFloatingLabel(fieldValue);

  const labelClassName = cn(
    $.floatingLabel,
    showFloatingLabel && $.floatingLabelActive,
    disabled && $.floatingLabelDisabled,
    required && $.required,
    className,
  );

  return (
    <div
      className={$.inputContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children({ handleFocus, handleBlur, id: formItemId })}

      <label htmlFor={formItemId} className={labelClassName}>
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelWrapper;
